require("./bootstrap");

// vue
import { createApp, h } from "vue";

// inertia
import {
    App as InertiaApp,
    plugin as InertiaPlugin,
} from "@inertiajs/inertia-vue3";

// axios
import axios from "axios";
import VueAxios from "vue-axios";

// localization
import { i18n } from "./plugins/vue-i18n";
// Inertia link
import { Link, Head } from "@inertiajs/inertia-vue3";

const el = document.getElementById("app");

// vue-cookies
import VueCookies from "vue-cookies";

// highlight.js
import hljs from "highlight.js/lib/core";
import "highlight.js/styles/a11y-dark.css";
hljs.initHighlightingOnLoad();

// import vue-toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// tocas
import "tocas/dist/tocas.min.js";
import "tocas/dist/tocas.min.css";

const ToastOptions = {
    pauseOnHover: false,
    draggable: false,
    draggablePercent: 0.6,
    closeOnClick: false,
    hideProgressBar: true,
    position: "bottom-right",
    transition: "Vue-Toastification__fade",
    maxToasts: 5,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {
        if (toasts.filter((t) => t.type === toast.type).length !== 0) {
            // Returning false discards the toast
            return false;
        }
        // You can modify the toast if you want
        return toast;
    },
};

// === AOS ===
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();
// === AOS ===

// === InertiaProgress ===
import { InertiaProgress } from "@inertiajs/progress";

// InertiaProgress setting
InertiaProgress.init({
    delay: 250, // The delay after which the progress bar will appear during navigation, in milliseconds.
    color: "#29d", // The color of the progress bar.
    includeCSS: true, // Whether to include the default NProgress styles.
    showSpinner: true, // Whether the NProgress spinner will be shown.
});
// === InertiaProgress ===

// vue inertia entry
const app = createApp({
        render: () =>
            h(InertiaApp, {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: (name) => require(`@/Frontend/${name}`).default,
            }),
    })
    .use(InertiaPlugin)
    .use(i18n)
    .use(Toast, ToastOptions)
    .component("InertiaLink", Link)
    .component("Head", Head)
    .use(VueAxios, axios)
    .use(VueCookies, { expire: "10y" });

window.postMessage({
        devtoolsEnabled: true, // 開啟vue-devtools
        vueDetected: true,
    },
    "*"
);

app.mount("#app");

var loginned = false;
const logoutCheck = setInterval(function() {
    // method to be executed;
    axios
        .get("/loginned")
        .then(() => {
            loginned = true;
        })
        .catch(() => {
            if (loginned) window.location.href = "/";
        });
}, 120000);